import * as React from 'react';

const Content = ({ children }) => (
  <div className="columns is-centered">
    <div className="column is-8-widescreen">{children}</div>
  </div>
);

export default Content;
